import { API_BASE } from '../../constants';
import { makeHttpGet } from '../';
import { ComparisonFundStatsUseCase } from '../../usecases';
import {
  IComparisonStats,
  IFundStats,
  IGetAssetColorRepo,
  IGetAssetMemory,
  ISetAssetMemory
} from '../../interfaces';

export const makeComparisonFundStats = (
  fundColorRepo: IGetAssetColorRepo,
  fundMemoryRepo:  IGetAssetMemory<IFundStats> & ISetAssetMemory<IFundStats>
) => {
  const url = `${API_BASE}/funds/stats`;
  const httpGet = makeHttpGet<IComparisonStats>();

  return new ComparisonFundStatsUseCase(
    url,
    httpGet,
    fundColorRepo,
    fundMemoryRepo
  );
}
